import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class LabService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'catalog/lab/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter  + "&trash=" + req.trash;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(catalog){
        let requestUrl = environment.apiUrl + 'catalog/lab/store';
        return this.http.post(requestUrl, catalog).map( (res: any) => {
            return res;
        });
    }

    edit(catalog){
        let requestUrl = environment.apiUrl + 'catalog/lab/update/' + catalog.id;
        return this.http.put(requestUrl, catalog).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'catalog/lab/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'catalog/lab/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'catalog/lab/delete/' + id;
        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/lab.service.ts